module.exports = __webpack_public_path__ + "static/media/4.1aaa7fe6.png";